import PreviewProducts from '@/util/preview-products'

import { getComponentSpecs, getBoxObject } from "dreamroi-box-generator"

export default {
    data() {
        return {
            minify: process.env.NODE_ENV == 'production' ? '.min' : '',
            cssTemplate: `div.dreamroi-${this.name} div#dreamroi-box {
    /* The whole box */
}

div.dreamroi-${this.name} div.dreamroi_track {
    /* The box without the arrows */
}

div.dreamroi-${this.name} li.dreamroi_product_card {
    /* Product card  - one item in the slider */
}

div.dreamroi-${this.name} img.dreamroi_product_img {
    /* Product image */
}

div.dreamroi-${this.name} div.dreamroi_product_name {
    /* Product name container */
}

div.dreamroi-${this.name} a.dreamroi_product_href {
    /* The product name and link */
}

div.dreamroi-${this.name} div.dreamroi_product_description {
    /* Description container */
}
            
div.dreamroi-${this.name} div.dreamroi_product_price {
    /* Price container */
}

div.dreamroi-${this.name} div.dreamroi_product_sale {
    /* Sale container */
}

div.dreamroi-${this.name} div.dreamroi_product_btn_container {
    /* Button container */
}
            
div.dreamroi-${this.name} a.dreamroi_product_btn {
    /* Button */
}

div.dreamroi-${this.name} div.dreamroi_arrows {
    /* Arrows block */
}

div.dreamroi-${this.name} button.dreamroi_arrow {
    /* Common arrow styling */
}

div.dreamroi-${this.name} button.dreamroi_arrow_left {
    /* Left arrow */
}

div.dreamroi-${this.name} button.dreamroi_arrow_right {
    /* Right arrow */
}
`
        }
    },
    computed: {
      previewProducts() {
        let sizes = ['200x300','300x200', '300x300'];
        return PreviewProducts.map((p,i) => {
          let price = parseInt(p.price.replace(' Kč', ''));
          return {
            name: p.name,
            url: 'https://dreamroi.com',
            description: p.description,
            price,
            salePrice: Math.floor((price / 100) * (100 - p.sale)), 
            image: require(`@/assets/newsletter-preview/${sizes[Math.round(Math.random() * 2)]}/${i+1}.jpg`),
          }
        })
      }
    },
    methods: {
        getVisibleCardComponents() {
            //console.debug('Visible components');
            //console.debug(encodeURIComponent(this.getConfig('button', 'button', 'js', 'text')));
            return this.cardComponents.slice(0, this.cardComponents.findIndex(i => i.divider)).map(i => {
              return getComponentSpecs(i.value, this.b.config);
              /*
              if(i.value == 'BUTTON') {
                return `{ type: 'button', encoded: true, text: '${encodeURIComponent(this.getConfig('button', 'button', 'js', 'text') || 'Buy')}'}`
              }
    
              if(i.value == 'SALE') {
                let t = this.getConfig('sale', 'sale', 'js', 'template');
                let d = this.getConfig('sale', 'sale', 'js', 'defaultPercent');
                return `{ type: 'sale'${t ? ", encoded: true, template: '"+encodeURIComponent(t) + "'": ""}${d ? ", defaultPercent: " + d : ""} }`
              }
    
              if(i.value == 'DESCRIPTION') {
                let l = this.getConfig('description', 'description', 'js', 'maxLength');
                if(l) {
                    return `{ type: 'description', maxLength: ${l}}`;
                }
              }
    
              return `'${i.value.toLowerCase()}'`;
              */
            });
        },

        getBoxObject(preview) {
          return JSON.stringify(getBoxObject(this.name, this.b.config, this.getVisibleCardComponents(), null, { preview }), null, 8);
          /*
          var cuSplC = this.getConfig('card','global','js','customSplideConfig');
          var newTab = this.getConfig('card','global','js','newTab') ? `        newTab: true,\n` : ``;
          var height = this.util.hasHeight && !cuSplC ? `        height: '${this.getConfig('image','image','js', 'height')}',\n`: ``;
          var gap = this.util.hasGap && !cuSplC ? `        gap: ${this.getConfig('card','global','js','gap')},\n` : ``; 
          var splideConfig =  cuSplC ? `        splide: { todo: 'TODO ADD YOUR SPLIDE.JS CONFIG HERE - SEE https://splidejs.com/options/' },\n` : ``; 
          var contain = this.getConfig('image','image','js', 'contain') ? `        contain: true,\n` : ``;
          var cart = this.box == 'cart' ? `        cart: true,\n` : ``;
          return `{  
        mode: '${this.getConfig('card','global','js','domMode')?.toLowerCase() || 'into'}', 
        selector: '${preview ? '#dreamroibox' : (this.getConfig('card','global','js','domId') || '#dreamroibox')}', 
        cardWidth: ${this.getConfig('card','global','js','cardWidth')},
        fields: [${this.getVisibleCardComponents().join(`,`)}],
${cart}${contain}${newTab}${height}${gap}${splideConfig}        utm: {
          campaign: '${this.getConfig('card','global','js','utmCampaign') || this.name},'
        },
        ${preview ? '' : "title: { content: 'DOPORUČENO PŘÍMO PRO VÁS', tag: 'h2' }" }
      }`*/
        },
        getBoxInsert(platform, preview) {
          if(preview) {
            return `roi.showBox(${this.getBoxObject(true)});`
          }
          else if(platform == 'SHOPTET') { 
              let pageType = 'homepage'
              if(this.name == 'product') {
                pageType = 'productDetail'
              }
              if(this.name =='cart') {
                pageType = 'cart';
              }
              return `var droi_pageType = getShoptetDataLayer('pageType');
    if(droi_pageType == '${pageType}') {
      dreamroi_initBox({ box: { type: '${this.name}', backend: true } });
    }`.replace('}});', '      }});');
          } else {
            return `roi.showBox(${this.getBoxObject()});`.replace('});', '    });')
          }
          
        },
        getExternalScripts(platform) {
          /* eslint-disable no-useless-escape */
          if(platform == 'WOOCOMMERCE') {
            return '';
          }
          var splideCore = this.getConfig('card','global','js','customArrowStyle') ? '-core' : '';
          let scripts = `<script defer src="${this.baseUrl}/client/v1/dreamroi-splide-box${this.minify}.js"><\/script> 
<script defer src="${this.baseUrl}/client/v1/splide/splide.min.js"><\/script>
<link rel="stylesheet" href="${this.baseUrl}/client/v1/splide/splide${splideCore}.min.css" media="print" onload="this.media='all'; this.onload=null;">
<link rel="stylesheet" href="${this.baseUrl}/client/v1/dreamroi${this.minify}.css" media="print" onload="this.media='all'; this.onload=null;">`;
return scripts;
          /* eslint-enable no-useless-escape */
        },
        getJavascriptTemplate(platform, preview) {
            /* eslint-disable no-useless-escape */
            if(!this.b) {
              return null;
            }           
            let style = '';
            if(this.getConfig('card','global','js','customCardStyle')) {
              style = `<!-- TODO INCLUDE YOUR MODIFIED CSS TEMPLATE HERE -->`;
            } else if(platform != 'SHOPTET') {
              style = `<style>
${this.getCSS()}
</style>`;
            }
            var template = `<!-- DreamROI Box code - COMMON (copy only once for all the boxes) -->
${this.getExternalScripts(platform)}
${style}
<!-- DreamROI Box code - ${this.name.toUpperCase()} -->
<script>
  window.addEventListener('DOMContentLoaded', function() {
    ${this.getBoxInsert(platform, preview)}
  });
<\/script>`;
      return template;
      /* eslint-enable no-useless-escape */
          },
        getPreviewCode() {
            /* eslint-disable no-useless-escape */
            if(!this.b) {
              return null;
}
            var code = `<!doctype html>
    <html lang="en">
    <head>
      <meta charset="utf-8">
      <title>DreamROI box preview<\/title>
      <meta name="description" content="DreamROI box preview">
      <meta name="author" content="DreamROI">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Quicksand:100,300,400,500,700,900">
      <style>
        body {
          width: 100%;
          margin: auto;
          font-family: Quicksand, Verdana, sans-serif;
        }
        .btn {
          display: block;
          width: 80px;
          height: 20px;
          background: #888;
          padding: 10px;
          text-align: center;
          border-radius: 5px;
          color: white;
          font-weight: bold;
          line-height: 20px;
          text-decoration: none;
        }
      <\/style>
      <!-- DreamROI tracker code -->
      <script defer src="${this.baseUrl}/client/v1/box-preview.js"><\/script>
      <script>
        window.addEventListener('DOMContentLoaded', function() { roi.init({log: true, currency: 'CZK', i18n: {
          name: 'Product name',
          longName: 'Extremely long product name with valuable pieces of information about the product', 
          image: 'Product image', 
          description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Integer vulputate sem a nibh rutrum consequat. Nullam faucibus mi quis velit. Nullam dapibus fermentum ipsum. Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien.',
        },
        products: ${JSON.stringify(this.previewProducts)},
        media: '${this.baseUrl}',
        defaultSale: 0
      }) });
      <\/script>
      ${this.getJavascriptTemplate('OTHER', true)}
      </head>
      <body>
      <div id="dreamroibox"></div>
      </body>
    </html>
      `;
        /* eslint-enable no-useless-escape */
            //return `data:text/html;charset=UTF-8;base64,${btoa(code)}`;
            //console.debug('preview code', code);
            return code;
          },
    }
}